import { combineReducers } from 'redux'

import contactsReducer from './Contacts/reducer'

import layoutReducer from "./Layout/reducer"


// //Invoices
import invoicesReducer from "./Invoices/reducer";

//register
import registerReducer from "./Auth/Register/reducer";

//login
import loginReducer from "./Auth/Login/reducer";


// // User Profile 
import profileReducer from "./Auth/Profile/reducer";

// // Forget Password
import forgetPasswordReducer from "./Auth/Forgetpwd/reducer";

//agency
import agencyReducer from "./Auth/Agency/reducer";

//clients
import clientsReducer from  "./Clients/reducer";

//oreders
import ordersReducer from "./Orders/reducer";

//filters
import filtersReducer from "./Filters/reducer";

//Proposals
import proposalReducer from "./Proposals/reducer";

//Report
import reportsReducer from "./Report/reducer";

//Compare
import compareReducer from "./Compare/reducer";

//TabData
import tabDataReducer from "./TabData/reducer";

const appReducer = combineReducers({
  contacts: contactsReducer,
  Layout: layoutReducer,
  invoices: invoicesReducer,
  register: registerReducer,
  login: loginReducer,
  forgetPassword: forgetPasswordReducer,
  profile: profileReducer,
  agency: agencyReducer,
  clients: clientsReducer,
  orders: ordersReducer,
  filters: filtersReducer,
  proposals : proposalReducer,
  reports : reportsReducer,
  compare : compareReducer,
  tabData: tabDataReducer,
});

const rootReducer = (state: any, action: any) => {
  // Listen for the LOGOUT_USER action and reset the state
  if (action.type === 'LOGOUT_USER') {
    state = undefined;  // This resets the store state
  }
  return appReducer(state, action);
};

export default rootReducer;
